"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = require("@eres/core/dist/StringUtils");
function matchObject(item, query) {
    if (StringUtils_1.isEmptyStringOrNull(query))
        return true;
    var values = ToValueArrays(item);
    var searchString = query.toLowerCase();
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var value = values_1[_i];
        if (value.toString().toLowerCase().indexOf(searchString) != -1) {
            return true;
        }
    }
    return false;
}
exports.matchObject = matchObject;
function filterObjects(items, query) {
    if (StringUtils_1.isEmptyStringOrNull(query))
        return items !== null && items !== void 0 ? items : [];
    var r = [];
    if (!items)
        return [];
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (matchObject(item, query)) {
            r.push(item);
        }
    }
    return r;
}
exports.filterObjects = filterObjects;
function ToValueArrays(data, x) {
    var r = x !== null && x !== void 0 ? x : [];
    if (data) {
        if (typeof data === "object") {
            var vals = Object.values(data);
            for (var _i = 0, vals_1 = vals; _i < vals_1.length; _i++) {
                var val = vals_1[_i];
                ToValueArrays(val, r);
            }
        }
        else if (typeof data === "function") {
        }
        else if (typeof data === "undefined") {
        }
        else if (typeof data === "symbol") {
        }
        else {
            r.push(data);
        }
    }
    return r;
}
exports.ToValueArrays = ToValueArrays;
